import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr/index';
import { logger } from '@/utils/logger';

const STORAGE_KEY = 'facturxpro-language';

const savedLanguage = typeof window !== 'undefined'
  ? localStorage.getItem(STORAGE_KEY) || 'fr'
  : 'fr';

// Always log in dev to debug translation loading
if (import.meta.env.DEV) {
  const keys = typeof fr === 'object' && fr !== null ? Object.keys(fr) : [];
  logger.debug('[i18n] fr object type:', typeof fr, '| keys count:', keys.length, '| keys:', keys);
  logger.debug('[i18n] Sample auth.login.title:', (fr as Record<string, Record<string, Record<string, string>>>)?.auth?.login?.title);
  logger.debug('[i18n] Language:', savedLanguage);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
    },
    lng: savedLanguage,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    fallbackNS: 'translation',
    returnNull: false,
    react: {
      useSuspense: false,
    },
    missingKeyHandler: import.meta.env.DEV
      ? (_lngs: readonly string[], _ns: string, key: string) => {
          logger.warn(`[i18n] Missing key: "${key}"`);
        }
      : undefined,
    saveMissing: import.meta.env.DEV,
  });

i18n.on('languageChanged', (lng: string) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  }
});

export default i18n;
